import { ResponseType } from 'axios';
import { SESSION_STORAGE_KEYS, SessionStorage } from 'utils';
import api from 'utils/api';

export type ApiResponse<T> = Promise<{ data: T }>;

interface GraphQLQuery {
  /** GraphQL query string */
  query: string;
  /** Object with variables that GraphQL will parse into the query */
  variables?: Record<string, unknown>;
  /** Name or identifier that is passed as a query parameter to the request for easier debugging */
  name: string;
  headers?: Record<string, unknown>;
}

export const query = <T>({ query, variables = {}, name, headers }: GraphQLQuery, authenticated = true): Promise<T> => {
  return api.apiV1.getFromGraphQL(
    {
      url: name,
      data: {
        query,
        variables,
      },
      headers: {
        ...headers,
        agentId: SessionStorage.get(SESSION_STORAGE_KEYS.agentId) || '',
        'Correlation-Id': crypto.randomUUID(),
      },
    },
    authenticated
  );
};

interface RestOptions {
  url: string;
  method: string;
  params?: Record<string, unknown>;
  data?: Record<string, unknown>;
  headers?: Record<string, string>;
  authenticated?: boolean;
  responseType?: ResponseType | undefined;
}

export const rest = <T>({
  url,
  method,
  params,
  headers,
  data,
  authenticated,
  responseType,
}: RestOptions): Promise<T> => {
  return api.apiV1.getFromRest<T>(
    {
      url,
      method,
      params,
      data,
      headers: {
        'Content-Type': 'application/json',
        'Correlation-Id': crypto.randomUUID(),
        ...headers,
      },
      responseType,
    },
    authenticated
  );
};
